export const MESSAGE_CHAR_LIMIT = 5000;

export const ATTACHMENT_MAX_SIZE_BYTES = 3 * 1024 * 1024; // 3MB
export const ATTACHMENT_MAX_FILES = 10;
export const ATTACHMENT_MAX_FILENAME_LENGTH = 88;

export const ATTACHMENT_ALLOWED_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.pdf',
  '.docx',
  '.pptx',
  '.xlsx',
  '.zip',
] as const;

export const ATTACHMENT_ALLOWED_ACCEPT = ATTACHMENT_ALLOWED_EXTENSIONS.join(',');

export const ATTACHMENT_FORBIDDEN_CHARS = /[:<>/\\"*^|?]/;

export const MESSAGES_RETENTION_WINDOW_MONTHS = 3;

export const MESSAGES_POLICY_STATUSES = {
  inProgress: 'IN_PROGRESS',
  completed: 'COMPLETED',
  cancelled: 'CANCELLED',
} as const;

// Legacy behavior for statuses outside TLS-1980 retention policy scope.
export const MESSAGES_LEGACY_READONLY_STATUSES = [] as const;

export const MESSAGES_LEGACY_ENABLED_STATUSES = [
  'AWAITING_DTP_PROCESS',
] as const;
